module.exports = __webpack_public_path__ + "img/ic-money-2.3c3ab64d.png";